import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum TenantFileType {
  InstallmentScheduler = 1,
  InstallmentMovements = 2,
  ChangeInBatch = 3,
  CancelContractInBatch = 4,
  BankslipTemplate = 5,
  BRCodeTemplate = 6,
  Campaign = 7,
  PointOfSaleTemplate = 8,
}
EnumDescriptions.setDescriptions(TenantFileType, [
  i18n.t('enums.installmentScheduler'),
  i18n.t('enums.installmentMovements'),
  i18n.t('enums.changeInBatch'),
  i18n.t('enums.cancelContractInBatch'),
  i18n.t('enums.bankslipTemplate'),
  i18n.t('enums.bRCodeTemplate'),
  i18n.t('enums.campaign'),
  i18n.t('enums.pointOfSaleTemplate'),
]);
